import React from 'react';
import { GRID_SIZE } from './logic';
import './Battleship.css';

const BattleshipBoard = ({
  myShips = [],
  myAttacks = null,
  opponentAttacks = null,
  onCellClick,
  isPlacementPhase = false,
  disabled = false,
}) => {
  const rows = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J'];

  // Create a grid to show ship positions
  const getShipAt = (row, col) => {
    if (!Array.isArray(myShips)) return null;
    return myShips.find(ship =>
      ship && ship.positions && Array.isArray(ship.positions) &&
      ship.positions.some(pos => pos && pos.row === row && pos.col === col)
    );
  };

  // Get cell content for placement phase
  const getPlacementCellContent = (row, col) => {
    const ship = getShipAt(row, col);

    if (ship) {
      const isHit = opponentAttacks && opponentAttacks[row] && opponentAttacks[row][col] === 'hit';
      const shipInitial = typeof ship.name === 'string' ? ship.name.charAt(0) : '?';

      return (
        <div className={`ship-cell ${isHit ? 'hit' : ''}`}>
          {shipInitial}
        </div>
      );
    }

    // Show opponent's attacks
    if (opponentAttacks && opponentAttacks[row] && opponentAttacks[row][col] === 'miss') {
      return <div className="miss-marker">⚪</div>;
    }

    return null;
  };

  // Get cell content for battle phase
  const getBattleCellContent = (row, col) => {
    if (!myAttacks || !myAttacks[row]) return null;

    const attack = myAttacks[row][col];

    if (attack === 'hit') {
      return <div className="hit-marker">💥</div>;
    } else if (attack === 'miss') {
      return <div className="miss-marker">⚪</div>;
    }

    return null;
  };

  const getCellClasses = (row, col) => {
    const classes = ['battleship-cell'];

    if (isPlacementPhase) {
      // In placement phase, show ships
      const ship = getShipAt(row, col);
      if (ship) {
        classes.push('has-ship');
      }

      // Show opponent hits on my ships
      if (opponentAttacks && opponentAttacks[row] && opponentAttacks[row][col] === 'hit') {
        classes.push('hit');
      }
      if (opponentAttacks && opponentAttacks[row] && opponentAttacks[row][col] === 'miss') {
        classes.push('miss');
      }
    } else {
      // In battle phase, show my attacks on opponent
      if (myAttacks && myAttacks[row] && myAttacks[row][col] === 'hit') {
        classes.push('hit');
      }
      if (myAttacks && myAttacks[row] && myAttacks[row][col] === 'miss') {
        classes.push('miss');
      }
      if (myAttacks && myAttacks[row] && myAttacks[row][col] === null && !disabled) {
        classes.push('attackable');
      }
    }

    if (disabled) {
      classes.push('disabled');
    }

    return classes.join(' ');
  };

  return (
    <div className="battleship-board-wrapper">
      <div className="battleship-board">
        {/* Column headers */}
        <div className="board-cell header-cell"></div>
        {Array.from({ length: GRID_SIZE }, (_, i) => (
          <div key={`col-${i}`} className="board-cell header-cell">
            {i + 1}
          </div>
        ))}

        {/* Grid rows */}
        {Array.from({ length: GRID_SIZE }, (_, rowIdx) => (
          <React.Fragment key={`row-${rowIdx}`}>
            {/* Row header */}
            <div className="board-cell header-cell">{rows[rowIdx]}</div>

            {/* Row cells */}
            {Array.from({ length: GRID_SIZE }, (_, colIdx) => (
              <div
                key={`${rowIdx}-${colIdx}`}
                className={getCellClasses(rowIdx, colIdx)}
                onClick={() => !disabled && onCellClick(rowIdx, colIdx)}
              >
                {isPlacementPhase
                  ? getPlacementCellContent(rowIdx, colIdx)
                  : getBattleCellContent(rowIdx, colIdx)}
              </div>
            ))}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

export default BattleshipBoard;
